import { ChatMessageTypes } from '../types/ChatMessageTypes';

/**
 * Utility class to get Bootstrap icon class names for ChatMessageTypes
 */
export class ChatMessageTypeIcon {
  /**
   * Returns the Bootstrap icon class for a given ChatMessageTypes value
   * @param messageType The ChatMessageTypes enum value
   * @returns The Bootstrap icon class name (e.g., 'bi-chat-left-text')
   */
  static getIcon(messageType: ChatMessageTypes | null | undefined): string {
    switch (messageType) {
      case ChatMessageTypes.Chat:
        return 'bi-chat-left-text';
      case ChatMessageTypes.Devotional:
        return 'bi-calendar-heart';
      case ChatMessageTypes.Commentary:
        return 'bi-book';
      default:
        return 'bi-chat-left-text';
    }
  }

  /**
   * Returns the full Bootstrap icon element class string
   * @param messageType The ChatMessageTypes enum value
   * @param additionalClasses Optional additional CSS classes
   * @returns The complete class string (e.g., 'bi bi-chat-left-text')
   */
  static getIconClass(
    messageType: ChatMessageTypes | null | undefined,
    additionalClasses?: string
  ): string {
    const icon = this.getIcon(messageType);
    const classes = ['bi', icon];
    if (additionalClasses) {
      classes.push(additionalClasses);
    }
    return classes.join(' ');
  }
}
